import React from 'react';
import { MdBusiness, MdPerson } from 'react-icons/md';

import { styled } from '../theme';
import Image from './Image';

const SIZES = {
    small: 20,
    default: 40,
    medium: 80,
    big: 114,
};
export type AvatarSize = keyof typeof SIZES;
const getSize = (size: AvatarSize): number => SIZES[size ? size : 'default'];

export const RoundAvatarShape = 'round';
export const SquareAvatarShape = 'square';
export type AvatarShape = 'round' | 'square';

export const AccountAvatarType = 'account';
export const OrganizationAvatarType = 'organization';
export type AvatarType = 'account' | 'organization';

const getMissingAvatarIcon = (type: AvatarType) =>
    AccountAvatarType === type ? MdPerson : MdBusiness;

const MissingAvatarWrapper = styled('div')<{
    theme?: any;
    type?: AvatarType;
    shape?: AvatarShape;
    size?: number;
}>(({ theme, shape, size }) => ({
    borderRadius: shape === RoundAvatarShape ? '50%' : theme.borderRadius.base,
    border: '1px solid lightgray',
    padding: 0,
    boxSizing: 'border-box',
    width: size,
    height: size,
    minHeight: size,
    minWidth: size,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& svg': {
        display: 'block',
        width: '75%',
        height: '75%',
    },
}));

type Props = {
    className?: string;
    alt?: string;
    size?: AvatarSize;
    shape?: AvatarShape;
    src: string;
    type?: AvatarType;
};

const Avatar: React.FC<Props> = ({
    src,
    size = 'default',
    alt,
    className,
    shape = RoundAvatarShape,
    type = AccountAvatarType,
    ...props
}) => {
    const sizeValue = getSize(size);
    if (src) {
        const imageStyle = { height: sizeValue, width: sizeValue };
        const sizeGetter = () => sizeValue;

        return (
            <Image
                className={className}
                alt={alt}
                src={src}
                style={imageStyle}
                shape={shape}
                type={type}
                getSize={sizeGetter}
            />
        );
    }

    const IconComponent = getMissingAvatarIcon(type);

    return (
        <MissingAvatarWrapper className={className} size={sizeValue} shape={shape} type={type}>
            <IconComponent />
        </MissingAvatarWrapper>
    );
};

export default Avatar;
